import { useHistory } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Card, Col, Container, Button, Form } from "react-bootstrap";
import Joi from "joi";
import Logo from "../Components/Logo";
import { getPersistingQueryStrings } from "../helpers";
import useOTPHandler from "../Services/useOTPHandler";
import { getFirebaseToken } from "../common/utils";

let Register = () => {
  let [user, setUser] = useState({
    firstName: "",
    lastName: "",
    userMailID: "",
  });

  let [allowSubmit, setAllowSubmit] = useState(false);
  let [errorFN, setErrorFN] = useState(true);
  let [errorLN, setErrorLN] = useState(true);
  let [errorEmail, setErrorEmail] = useState(true);

  let { customerToken, register, setUserToken } = useOTPHandler.useContainer();

  let history = useHistory();

  useEffect(() => {
    const cmd = async () => {
      let { userToken } = await getFirebaseToken(customerToken);
      setUserToken(userToken || "");
    };

    if (customerToken) {
      cmd();
    } else {
      history.push("/");
    }
  }, []);

  let validateEmail = async (userMailID: string) => {
    try {
      Joi.assert(
        userMailID,
        Joi.string().email({ tlds: { allow: ["com", "net"] } })
      );
      return true;
    } catch (error) {
      return false;
    }
  };

  let handleChange = async (field: string, e: any) => {
    let value = e.target.value;
    if (field === "userMailID") {
      value = value.trim();
    }

    let newuser = { ...user, [field]: value };
    let emailErrValue = await validateEmail(newuser.userMailID);
    await setUser({ ...user, [field]: value });
    setErrorFN(false);
    setErrorLN(false);
    setErrorEmail(false);

    if (newuser.firstName.length < 3) {
      setErrorFN(true);
      setAllowSubmit(false);
    }

    if (newuser.lastName.length < 3) {
      setErrorLN(true);
      setAllowSubmit(false);
    }

    if (!emailErrValue) {
      setErrorEmail(true);
      setAllowSubmit(false);
    }

    if (newuser.firstName.length >= 2 && newuser.lastName.length >= 2 && emailErrValue) {
      setAllowSubmit(true);
    }
  };

  console.log({errorFN, errorLN, errorEmail})

  let handleSubmit = async (event: any) => {
    event.preventDefault();
    let result = await register(user);

    if (result) {
      history.push({
        pathname: "/success",
        search: getPersistingQueryStrings(),
      });
    }
  };
  return (
    <Card className="main-card d-flex align-items-center justify-content-center p-5 h-100 w-100">
      <Logo />
      <h2 className="create-text">Create an Account</h2>

      <Form>
        <Form.Row>
          <Form.Group as={Col} md="6" sm="12" controlId="firstName">
            <Form.Label>First name</Form.Label>
            <Form.Label style={{ marginLeft: "2px", color: "#FF0000" }}>
              *
            </Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Juan"
              size="lg"
              isValid={!errorFN && user.firstName.length > 0}
              onChange={(e) => handleChange("firstName", e)}
            />
            <Form.Control.Feedback></Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="6" controlId="firstName">
            <Form.Label>Last name</Form.Label>
            <Form.Label style={{ marginLeft: "2px", color: "#FF0000" }}>
              *
            </Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Dela Cruz"
              size="lg"
              isValid={!errorLN && user.lastName.length > 0}
              onChange={(e) => handleChange("lastName", e)}
            />
            <Form.Control.Feedback></Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} sm="12" controlId="userMailID">
            <Form.Label>Email</Form.Label>
            <Form.Label style={{ marginLeft: "2px", color: "#FF0000" }}>
              *
            </Form.Label>
            <Form.Control
              required
              size="lg"
              type="userMailID"
              placeholder="jdelacruz@gmail.com"
              isValid={!errorEmail}
              onChange={(e) => handleChange("userMailID", e)}
            />
          </Form.Group>
        </Form.Row>
        <div className="register-btn" style={{ textAlign: "center" }}>
          <Button
            size="lg"
            onClick={(e) => handleSubmit(e)}
            disabled={!allowSubmit}
          >
            Register
          </Button>
        </div>
      </Form>
    </Card>
  );
};

export default Register;
